import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
type PageId = 'om-mig' | 'omrade-1' | 'omrade-2' | 'omrade-3';
interface SubpageNavProps {
  activePage: PageId;
}
export function SubpageNav({
  activePage
}: SubpageNavProps) {
  const links = [{
    id: 'om-mig',
    label: 'Om mig',
    path: '/om-mig'
  }, {
    id: 'omrade-1',
    label: 'Leda utvecklingen',
    path: '/omrade-1'
  }, {
    id: 'omrade-2',
    label: 'Från ett team till tre',
    path: '/omrade-2'
  }, {
    id: 'omrade-3',
    label: 'Hybridarbete',
    path: '/omrade-3'
  }] as const;
  // Determine active color based on page
  const getActiveColorClass = (pageId: PageId) => {
    if (pageId === 'omrade-2') return 'border-sage';
    return 'border-terracotta';
  };
  return <motion.div className="fixed top-0 left-0 right-0 z-50 bg-background/90 backdrop-blur-sm border-b border-border/50" initial={{
    y: -60
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.4
  }} data-id="element-236">
      <div className="max-w-5xl mx-auto px-6 py-4 flex items-center justify-between" data-id="element-237">
        <Link to="/" className="flex items-center gap-2 text-muted hover:text-ink transition-colors text-sm group" data-id="element-238">
          <ArrowLeft className="w-4 h-4 group-hover:-translate-x-1 transition-transform" data-id="element-239" />
          Tillbaka
        </Link>

        {/* Area navigation */}
        <div className="hidden md:flex items-center gap-5" data-id="element-240">
          {links.map(link => {
          const isActive = activePage === link.id;
          return <Link key={link.id} to={link.path} className={`text-sm transition-colors ${isActive ? `font-medium text-ink border-b pb-0.5 ${getActiveColorClass(link.id)}` : 'text-muted hover:text-ink'}`} data-id="element-241">
                {link.label}
              </Link>;
        })}
        </div>

        <a href="mailto:peter@humble-consulting.se" className="bg-terracotta hover:bg-terracotta/90 text-white px-5 py-2 rounded-full text-sm font-medium transition-colors" data-id="element-242">
          Boka ett samtal
        </a>
      </div>
    </motion.div>;
}